import Main from './Main';
import ContentWrapper from './ContentWrapper';
import ContentSidebar from './ContentSidebar';
import ContentBody from './ContentBody';
import ContetnWrapperElement from './ContetnWrapperElement';
import ContentInner from './ContentInner';
import BaseLayout from './BaseLayout';
import Column from './Column';

export {
  Main,
  ContentWrapper,
  ContentSidebar,
  ContentBody,
  ContetnWrapperElement,
  ContentInner,
  BaseLayout,
  Column
};
